import {
  ExcelExportParams,
  ExcelRow,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-enterprise';
import { isObservable, Observable } from 'rxjs';

export class GridExportUtil {
  static exportSingleLine(
    headerText: string,
    dataValue: string | undefined,
  ): ExcelRow {
    return {
      cells: [
        { data: { value: headerText, type: 'String' }, styleId: 'bold' },
        {
          data: {
            value: dataValue || '',
            type: 'String',
          },
        },
      ],
    };
  }

  static gridContextMenuItems = (
    params: GetContextMenuItemsParams,
    excelExportParams: ExcelExportParams | Observable<ExcelExportParams>,
  ): (string | MenuItemDef)[] => {
    let cellRendererParams = params.column?.getColDef().cellRendererParams;

    return [
      {
        name: 'Open Link in New Tab',
        cssClasses:
          cellRendererParams &&
          cellRendererParams({ data: params?.node?.data, ...params })
            .urlCallback
            ? ['d-print-table-row', 'border', 'border-bottom']
            : ['d-none'],
        icon: '<span class="ag-icon ag-icon-linked" unselectable="on" role="presentation"></span>',
        action: () => {
          cellRendererParams = params.column?.getColDef().cellRendererParams;

          // FIXEME: The problem with this solution is that cellRendererParams can be a function.
          // In that case, this logic would not work for checking if urlCallback exists.
          if (
            cellRendererParams &&
            cellRendererParams({ data: params?.node?.data, ...params })
              .urlCallback &&
            typeof cellRendererParams({ data: params?.node?.data, ...params })
              .urlCallback === 'function'
          ) {
            if (params.column) {
              const urlPath = params.column
                .getColDef()
                .cellRendererParams({ data: params?.node?.data, ...params })
                .urlCallback(params);

              window.open(urlPath, '_blank')?.focus();
            }
          }
        },
      },
      cellRendererParams &&
      cellRendererParams({ data: params?.node?.data, ...params }).urlCallback
        ? 'separator'
        : '',
      'copy',
      'copyWithHeaders',
      'paste',
      'separator',
      {
        name: 'Export',
        icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
        subMenu: [
          'csvExport',
          {
            name: 'Excel Export (.xlsx)',
            icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
            action: async () => {
              let exportParams = excelExportParams;
              if (isObservable(exportParams)) {
                exportParams =
                  (await exportParams.toPromise()) as ExcelExportParams;
              }
              params.api.exportDataAsExcel(exportParams);
            },
          },
        ],
      },
    ];
  };
}
